<template>
    <div>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row class="px-4 pt-2">
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-if="$store.getters.role <= 3"
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    @input="filterDashboardStats(); getAuthBreachLevels(); getDashboardUserStats();"
                ></v-autocomplete>
                <v-select
                    v-else
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    @input="filterDashboardStats(); getAuthBreachLevels(); getDashboardUserStats();"
                ></v-select>
            </v-col>
        </v-row>

        <v-row v-if="chartData" class="px-4">
            <v-col md="4" class="pa-2">
                <chart1
                    ref="chart1"
                    :chartData="chartData"
                ></chart1>
            </v-col>
             <v-col md="4" class="pa-2">
                <chart2
                    ref="chart2"
                    :chartData="chartData"
                ></chart2>
            </v-col>
            <v-col md="4" class="pa-2">
                <chart3
                    ref="chart3"
                    :chartData="chartData"
                ></chart3>
            </v-col>

            <v-col v-if="chartData" md="4" class="px-3 pt-0">
                <v-row>
                    <v-col v-if="authLevels" md="12" class="pa-2">
                        <v-card class="pa-2" color="#42A5F5">
                            <v-card-subtitle class="text-center white--text py-2"><b>Authorisation Statistics For {{ authLevels[0].monthName }}</b></v-card-subtitle>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Total Transactions:</b> {{ authLevels[0].totalTransactions }} / 20,000</v-card-text>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Visa Transactions:</b> {{ authLevels[0].visaTotal }}</v-card-text>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Mastercard Transactions:</b> {{ authLevels[0].masterTotal }}</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col v-if="authLevels" md="6" class="pa-2">
                        <v-card class="pa-2" color="#42A5F5" :class="breach">
                            <v-card-subtitle class="text-center white--text py-2"><b>Visa Statistics</b></v-card-subtitle>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Successful:</b> {{ authLevels[0].visaSuccess }} / {{ authLevels[0].visaSuccessRatio }}%</v-card-text>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Failure:</b> {{ authLevels[0].visaFail }} / {{ authLevels[0].visaFailureRatio }}%</v-card-text>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Breach Threshold:</b> {{ authLevels[0].visaBreach }}%</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col v-if="authLevels" md="6" class="pa-2">
                        <v-card class="pa-2" color="#42A5F5" :class="breach">
                            <v-card-subtitle class="text-center white--text py-2"><b>Mastercard Statistics</b></v-card-subtitle>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Successful:</b> {{ authLevels[0].masterSuccess }} / {{ authLevels[0].masterSuccessRatio }}%</v-card-text>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Failure:</b> {{ authLevels[0].masterFail }} / {{ authLevels[0].masterFailureRatio }}%</v-card-text>
                            <v-card-text class="white--text px-2 py-0 caption"><b>Breach Threshold:</b> {{ authLevels[0].masterBreach }}%</v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>

            <v-col v-if="userStats && userStats.length > 0" md="4" class="pa-2">
                <v-card class="pa-2" color="#42A5F5">
                    <v-card-subtitle class="text-center white--text py-2">User Statistics for {{ monthName }}</v-card-subtitle>
                    <v-data-table
                        :headers="headers4"
                        :items="userStats"
                        class="table-blue"
                        hide-default-footer
                        dense
                    >
                        <template v-slot:item.val="{ item }">
                            {{ Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(item.val )}}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import Revenue from '@/components/dashboards/charts/Revenue.vue';
import Refund from '@/components/dashboards/charts/Refund.vue';
import RevenueFailed from '@/components/dashboards/charts/RevenueFailed.vue';

export default {
    components: {
        'chart1': Revenue,
        'chart2': Refund,
        'chart3': RevenueFailed
    },
    data() {
        return {
            chartData: null,
            merchants: null,
            merchant: null,
            loading: true,
            authLevels: null,
            userStats: null,
            headers4: [{ text: 'Agent', value: 'agent', sortable: false, align: 'left' },
                       { text: 'Cards', value: 'cards', sortable: false, align: 'left' },
                       { text: 'Payments', value: 'vol', sortable: false, align: 'left' },
                       { text: 'Revenue', value: 'val', sortable: false, align: 'left' }]
        }
    },
    watch: {
        uri() {
            this.merchant = null;
            this.getMerchants();
        }
    },
    computed: {
        uri() {
            return this.$store.state.sysState ? 'live' : 'test';
        },
        breach: function() {
            return this.authLevels[0].visaBreach <= 50.00 ? 'breach-green'
                   : this.authLevels[0].visaBreach > 50.00 && this.authLevels[0].visaBreach <= 75.00 ? 'breach-orange'
                   : 'breach-red';
        }
    },
    beforeMount() {
        this.getMerchants();
    },
    methods: {
        filterDashboardStats() {
            this.loading = true;

            if(this.merchant) {
                axios({
                method: 'post',
                url: `filter-dashboard-stats-${this.uri}`,
                data: { merchant: this.merchant },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.loading = false;
                    this.chartData = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getMerchants() {
            axios({
            method: 'post',
            url: `get-merchants-${this.uri}-client`,
            data: { userId: this.$store.state.user.id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.merchants = response.data;
                this.merchant = this.merchants[0].uuid;
                this.filterDashboardStats();
                this.getAuthBreachLevels();
                this.getDashboardUserStats();
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getAuthBreachLevels() {
            if(this.merchant && this.uri == 'live') {
                axios({
                method: 'post',
                url: `get-auth-breach-levels-${this.uri}`,
                data: { merchant: this.merchant },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.authLevels = null;
                    this.authLevels = response.data.length ? response.data : null;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getDashboardUserStats() {
            if(this.merchant && this.uri == 'live') {
                axios({
                method: 'post',
                url: `get-dashboard-user-stats-${this.uri}`,
                data: { merchant: this.merchant },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.userStats = response.data;
                    console.log(this.userStats);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                this.userStats = null;
            }
        }
    }
}
</script>

<style>

</style>